import React from "react";
import { Briefcase, Ship, Sparkles, AlertTriangle, Rocket } from "lucide-react";

const audiences = [
  { icon: Briefcase, label: "Właściciele firm transportowych" },
  { icon: Ship, label: "Właściciele spedycji" },
  { icon: Sparkles, label: "Osoby chcące wejść w branżę" },
  { icon: AlertTriangle, label: "Firmy w kryzysie lub zadłużeniu" },
  { icon: Rocket, label: "Przedsiębiorcy chcący skalować biznes" },
];

export default function ForWho() {
  return (
    <section id="dla-kogo" data-testid="forwho-section" className="section relative overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-[#0e0e10]" />
      <div className="container-x">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-10 mb-12">
          <div className="max-w-2xl">
            <span className="eyebrow">Dla kogo</span>
            <h2 className="h-display mt-4 text-[clamp(28px,3.6vw,44px)]">
              Z kim <span className="gold-gradient-text italic">pracuję</span>
            </h2>
            <div className="gold-line mt-6" />
          </div>
          <p className="text-[16px] leading-relaxed text-[#b8b3a7] max-w-md">
            Współpracuję z osobami, które chcą podejmować lepsze decyzje i budować
            biznes na solidnych fundamentach — nie na chaosie i przypadku.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {audiences.map((a, idx) => {
            const Icon = a.icon;
            return (
              <div
                key={a.label}
                data-testid={`audience-${idx}`}
                className="card-dark p-8 flex flex-col gap-6 min-h-[220px] justify-between"
              >
                <Icon className="text-[var(--gold)]" size={28} strokeWidth={1.3} />
                <div>
                  <div className="font-display text-[12px] tracking-[0.3em] text-[var(--gold)] mb-3">
                    0{idx + 1}
                  </div>
                  <div className="text-[15px] leading-snug text-[#f5f1e8]">
                    {a.label}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
